import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './externalSales.scss';
import { EXTERNAL_SALES_BASE_PATH } from './config';
import { CheckoutPage } from './pages/Checkout/CheckoutPage';
import { LandingPage } from './pages/Landing/LandingPage';
import { SuccessPage } from './pages/Success/SuccessPage';

export function ExternalSalesModule() {
  return (
    <Switch>
      <Route exact path={`${EXTERNAL_SALES_BASE_PATH}/c/:campaignCode`} component={LandingPage} />
      <Route exact path={`${EXTERNAL_SALES_BASE_PATH}/c/:campaignCode/checkout`} component={CheckoutPage} />
      <Route exact path={`${EXTERNAL_SALES_BASE_PATH}/success`} component={SuccessPage} />
      <Route render={() => <div className="external-sales-not-found">Campaign not found</div>} />
    </Switch>
  );
}
